import * as client from './baseClient';
import axios from 'axios';

export const getAttachmentsForSingle = (
  domainTypeId,
  parentId,
  loggedInUserId
) => {
  return client.get(
    `/api/attachments/${domainTypeId}/blobs/${parentId}`,
    loggedInUserId
  );
};

export const getAttachmentsForDomain = (domainTypeId, loggedInUserId) => {
  return client.get(`/api/attachments/${domainTypeId}/blobs`, loggedInUserId);
};

export const getDocumentsForBranch = (branchId) =>
  client.get(`/api/attachments/${branchId}/branch`);

export const deleteAttachments = (
  attachmentIdsString,
  loggedInUserId,
  branchId
) => {
  return client.get(
    `/api/attachments/deleteAttachments/${attachmentIdsString}/${branchId}`,
    loggedInUserId
  );
};

export const addAttachments = (
  domainTypeId,
  parentId,
  branchId,
  attachments
) => {
  for (let i = 0; i < attachments.length; i++) {
    try {
      const formData = new FormData();
      formData.append(
        attachments[i].name,
        attachments[i].fileData,
        attachments[i].name
      );
      axios
        .post(
          `/api/attachments/${domainTypeId}/blobs/${parentId}/${branchId}`,
          formData,
          {
            'Content-Type': 'multipart/form-data'
          }
        )
        .then((resp) => {})
        .catch((err) => {
          // Handle Error Here
          console.error(err);
        });
    } catch (ex) {}
  }
};
